import React from 'react';
import {
    Link
} from 'react-router-dom'
import './Entry.css';
import EntryConfig from './entryconfigType';


function Bottomnaventry({conf}: {conf:EntryConfig}) {
  return (
    <div key={conf.link}>
      <Link to={conf.link}>
        <img src={conf.img} alt={conf.img_alt} className='bottom-nav-img burg-img'/>
      </Link>
    </div>
  );
}

export default Bottomnaventry;